import { documentationActions } from '../../actions/constant';
import { applyHeldFromBilling } from './holdDailyNoteFromBillingReducer';
import { removeArchived } from '../dailySessionNotes/archiveDailySessionNoteReducer';
import { dailySessionNotes } from '../../actions/constant';

const {
  FAILURE_GET_ALL_COMPETED_DOCUMENT,
  SUCCESS_GET_ALL_COMPETED_DOCUMENT,
  RESET_GET_ALL_COMPETED_DOCUMENT,
  LOADER_GET_ALL_COMPETED_DOCUMENT,
  REQUEST_GET_ALL_COMPETED_DOCUMENT,
  HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isGetAllCompletedDoc: false,
  loader: false,
};

export const getAllCompetedDocReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_COMPETED_DOCUMENT: {
      return {
        ...state,
        isGetAllCompletedDoc: true,
        response: action.payload?.data,
        loader: false,
      };
    }

    case FAILURE_GET_ALL_COMPETED_DOCUMENT:
      return {
        ...state,
        isGetAllCompletedDoc: false,
        response: action.payload,
        loader: false,
      };

    case LOADER_GET_ALL_COMPETED_DOCUMENT:
      return {
        ...state,
        loader: true,
      };

    case HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS:
      return applyHeldFromBilling(state, action.payload);

    case dailySessionNotes.ARCHIVE_DAILY_SESSION_NOTE_SUCCESS:
      return removeArchived(state, action.payload);

    case RESET_GET_ALL_COMPETED_DOCUMENT:
      return intitialstate;
    default:
      return state;
  }
};
